module.exports = __webpack_public_path__ + "img/layer-map.9d20db5a.svg";